import GenericTemplate from "../../templates/GenericTemplate";
import {
  APOLLO_GROUP_OPERATOR,
  ApolloUserProfileAuth,
  APOLLO_PROFILE_SYSTEM_OPERATOR,
} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import React, {useState, useEffect} from "react";
import Card from "@material-ui/core/Card/Card";
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import Box from '@material-ui/core/Box';
import {useHistory} from "react-router-dom";
import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
  ApolloMessage,
  CustomizedSnackbars
} from "../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../atom/Apollo_Context";
import {
  put_tracker_id_migration_path,
  apollo_accounts_trackerid_migration_active_path
} from "../../atom/Apollo_links";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import Typography from "@material-ui/core/Typography";
import {ApolloButton} from "../../molecule/Apollo_ButtonBase";

const TrackerIdMigration: React.FC = () => {
  const {state} = React.useContext(ApolloContext);
  const classes = apollo_useStyles();
  const {data, setmsg} = React.useContext(ApolloMessage);

  const history = useHistory();

  const currentAccountId = state.current.accountId;
  const currentAaccountName = state.current.accountName;
  const currentAaccountGroupId = state.current.accountGroupId;
  const currentAaccountGroupName = state.current.accountGroupName;

  const width1 = "100px";
  const width2 = "200px";

  const statusTransferMigrated = 2;
  const statusTransferUnused = 3;

  // 画面表示項目
  const [sourceAccountId, setSourceAccountId] = useState<number>(0);
  const [sourceAccountName, setSourceAccountName] = useState<string>("");
  const [sourceAccountGroupId, setSourceAccountGroupId] = useState<number>(0);
  const [sourceAccountGroupName, setSourceAccountGroupName] = useState<string>("");
  const [destinationAccountId, setDestinationAccountId] = useState<number>(0);
  const [destinationAccountName, setDestinationAccountName] = useState<string>("");
  const [destinationAccountGroupId, setDestinationAccountGroupId] = useState<number>(0);
  const [destinationAccountGroupName, setDestinationAccountGroupName] = useState<string>("");
  const [isSourceAccountTrackerIdExists, setIsSourceAccountTrackerIdExists] = useState<boolean>(false);  
  const [isExistsDestinationAccount, setIsExistsDestinationAccount] = useState<boolean>(false);

  type resultType = "success" | "error";

  const MSG: string[] = [
    "トラッカーIDの移行が完了しました。",
    "トラッカーIDの移行を取消しました。",
    "トラッカーIDの移行が失敗しました。",
    "トラッカーID移行の取消が失敗しました。"
  ];
 
  const getMSG = (status: number, resultType: resultType): string => {
    if(status == statusTransferMigrated && resultType == "success") {
      return MSG[0];
    } else if(status == statusTransferUnused && resultType == "success") {
      return MSG[1];
    } else if(status == statusTransferMigrated && resultType == "error") {
      return MSG[2];
    } else if(status == statusTransferUnused && resultType == "error") {
      return MSG[3];
    } else {
      return "";
    }
  };


  const getTrackerIdMigrationAccountInfo = () => {
    setmsg({
      type: "loading",
      payload: {
      ...data,
      loading: true,
      }
    });
    // トラッカーID移行アカウント情報取得
    const path = apollo_accounts_trackerid_migration_active_path + "/" + currentAccountId;
    
    ApolloAxios.get(path).then(response => {
      if (response.data.resultCode === 0) {
        if((response.data?.result?.source_account_id ?? 0) === currentAccountId) {
          setSourceAccountId(response.data?.result?.source_account_id ?? 0);
          setSourceAccountName(response.data?.result?.source_account_name ?? "");
          setSourceAccountGroupId(response.data?.result?.source_account_group_id ?? 0);
          setSourceAccountGroupName(response.data?.result?.source_account_group_name ?? "");
          setDestinationAccountId(response.data?.result?.destination_account_id ?? 0);
          setDestinationAccountName(response.data?.result?.destination_account_name ?? "");
          setDestinationAccountGroupId(response.data?.result?.destination_account_group_id ?? 0);
          setDestinationAccountGroupName(response.data?.result?.destination_account_group_name ?? "");
          if((response.data?.result?.source_account_tracker_id ?? "") != ""){
            setIsSourceAccountTrackerIdExists(true);
          }
          if((response.data?.result?.destination_account_id ?? 0 != 0) &&
            (response.data?.result?.destination_account_name ?? "" != "") &&
            (response.data?.result?.destination_account_group_id ?? 0 != 0) &&
            (response.data?.result?.destination_account_group_name ?? "" != "")){
            setIsExistsDestinationAccount(true);
          }
        } else {
          setSourceAccountId(currentAccountId);
          setSourceAccountName(currentAaccountName);
          setSourceAccountGroupId(currentAaccountGroupId);
          setSourceAccountGroupName(currentAaccountGroupName);
        }
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      } else {
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
            loading: false,
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "all",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "トラッカーID移行元アカウント情報を取得できませんでした。",
          loading: false,
        }
      });
    });
  }

  // 移行実行又は取消の処理
  const setTrackerIdMigrationStatus = (status: number) => {
    let isSuccess = false;

    setmsg({
      type: "loading",
      payload: {
      ...data,
      loading: true,
      }
    });
    const request = {
      status: status,
    }
    const path = put_tracker_id_migration_path + "/" + currentAccountId;
    ApolloAxios.put(path, request).then(response => {
      if (response.data.resultCode === 0) {
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: getMSG(status, "success"),
            loading: false,
          }
        });
        isSuccess = true;
      } else {
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
            loading: false,
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "all",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: getMSG(status, "error") + "（" + err.errmsg + "）",
          loading: false,
        }
      });
    }).finally(() => {      
      if(isSuccess) {
        setIsExistsDestinationAccount(false);
      }
		});
  }

  // 初期表示処理
  useEffect(() => {
    getTrackerIdMigrationAccountInfo();
  }, []);

  // 移行実行ボタンハンドラ
  const handelMigration = () => {
    setTrackerIdMigrationStatus(statusTransferMigrated);
  };

  // 取消ボタンハンドラ
  const handelCancel = () => {
    setTrackerIdMigrationStatus(statusTransferUnused);
  };

  // 戻るボタンハンドラ
  const handelGoback = () => {
    history.goBack();
  };

  const sourceAccountInfo = [
    {name: 'アカウントグループID', value: sourceAccountGroupId},
    {name: 'アカウントグループ名', value: sourceAccountGroupName},
    {name: 'アカウントID', value: sourceAccountId},
    {name: 'アカウント名', value: sourceAccountName},
  ];
  const destinationAccountInfo = [
    {name: 'アカウントグループID', value: destinationAccountGroupId},
    {name: 'アカウントグループ名', value: destinationAccountGroupName},
    {name: 'アカウントID', value: destinationAccountId},
    {name: 'アカウント名', value: destinationAccountName},
  ];

  // 画面表示
  return (
  <GenericTemplate title="">
    <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
      <ApolloBreadcrumbs bread_no={79} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""} platform={""} />
        <Card className={classes.root} square variant="outlined">
          <Box p={2}>
            <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px", fontSize: "1.1rem"}}>
              トラッカーID移行元アカウント
            </Typography>
            {sourceAccountInfo?.map((accountInfo, index) => (
              <React.Fragment key={index}>
                <Grid container>
                  <Grid item><Box sx={{ width: width1 }} pb={1}></Box></Grid>
                  <Grid item><Box sx={{ width: width2 }} pb={1}><Typography>{accountInfo.name}</Typography></Box></Grid>
                  <Grid item><Box pb={1}>{accountInfo.value}</Box></Grid>
                </Grid>
              </React.Fragment>
            ))}
          </Box>
          <Box p={2}>
            <Typography variant="subtitle1" gutterBottom style={{marginTop: "5px", fontSize: "1.1rem"}}>
              トラッカーID移行先アカウント
            </Typography>
            {isExistsDestinationAccount? destinationAccountInfo.map((accountInfo, index) => (
              <React.Fragment key={index}>
                <Grid container>
                  <Grid item><Box sx={{ width: width1 }} pb={1}></Box></Grid>
                  <Grid item><Box sx={{ width: width2 }} pb={1}><Typography>{accountInfo.name}</Typography></Box></Grid>
                  <Grid item><Box pb={1}>{accountInfo.value}</Box></Grid>
                </Grid>
              </React.Fragment>
            )) : <Grid container>
              <Grid item>
                <Box sx={{ width: width1 }} pb={1}></Box>
              </Grid>
              <Grid item>
                移行先アカウントが設定されていません
              </Grid>
            </Grid>}
          </Box>
          <Box p={2}>
            <Grid container spacing={2}>
              <Grid item>
                <ApolloButton
                  handleButton={handelMigration}
                  button={"移行実行"}
                  title={"トラッカーID移行"}
                  text={"トラッカーID移行を実行しますか？"}
                  disabled={!isExistsDestinationAccount || !isSourceAccountTrackerIdExists}
                />
              </Grid>
              <Grid item>
                <ApolloButton
                  handleButton={handelCancel}
                  button={"取消"}
                  title={"トラッカーID移行取消"}
                  text={"トラッカーID移行を取消しますか？"}
                  disabled={!isExistsDestinationAccount || !isSourceAccountTrackerIdExists}
                />
              </Grid>
              <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handelGoback}
                    className={classes.buttonTop}
                  >
                    戻る
                </Button>
              </Grid>
            </Grid>
          </Box>          
        </Card>
      </ApolloUserProfileAuth>
      <CustomizedSnackbars />
  </GenericTemplate>
  );
};

export default TrackerIdMigration;